export function formatMoney(cents, decimal = 2, currency = 'CHF', empty = '-') {
  if (!cents) { return empty; }
  let formattedValue = (cents / 100).toFixed(decimal);
  const allZeros = `.${[...new Array(decimal)].map(() => '0').join('') }`;
  if (decimal > 0 && formattedValue.endsWith(allZeros)) {
    formattedValue = formattedValue.replace(allZeros, '.-');
  }
  return [currency, formattedValue].filter(Boolean).join(' ');
}
